import { styled, Typography, Link } from '@mui/material';

import { theme } from 'styles';

export const ContainerW = styled('div')`
  width: 100%;
`;

export const DetailsCard = styled('div')`
  margin-top: 16px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.7);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  backdrop-filter: blur(10px);
  border-radius: 8px;
  @media (max-width: 1023px) {
    padding: 16px;
  }
`;

export const AuthorSection = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const AuthorMeta = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AuthorInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AuthorName = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const DateTime = styled(Typography)`
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p030};
`;

export const Tag = styled('div')`
  padding: 3px 12px;
  border-radius: 10px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;

export const TagW = styled('div')`
  display: flex;
  align-items: center;
`;

export const TagContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const PostTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 12px;
`;

export const DescriptionW = styled(Typography)`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  overflow: hidden;
  white-space: break-spaces;
  word-wrap: break-word;

  & a {
    color: ${({ theme }) => theme.palette.info.main};
  }

  & p {
    margin: 12px 0;

    &:has(code) {
      margin: 8px 0;
    }
  }

  & h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 0;
    font-size: inherit;
  }
`;

export const SectionW = styled('div')`
  margin-top: 24px;
  padding-top: 16px;
`;

export const SectionLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 12px;
`;

export const DocsGridW = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const MediaSectionW = styled('div')`
  display: flex;
  gap: 24px;
  margin-top: 24px;
  padding-top: 16px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const MediaColumnW = styled('div')`
  flex: 1;
  min-width: 0;
`;

export const AttachmentsW = styled('div')`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  border-radius: 8px;
  row-gap: 8px;
  margin-top: 8px;
`;

export const FooterW = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const LinkW = styled(Link)`
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
  text-decoration-color: ${({ theme }) => theme.palette.info.main};
`;

export const WelcomeImage = styled('img')`,
  height: 118px;
  width: 118px;
  display: block;
  margin-top: 17px;
  object-fit: contain;
  @media (max-width: 1023px) {
    object-fit: contain;
    height: 87px;
    width: 87px;
    margin-top: 12px;
  }
`;
export const BirthdayImage = styled(WelcomeImage)``;

export const TargetW = styled('div')`
  margin: 24px 0 16px;
`;

export const PollDescription = styled('div')`
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const PostActionsW = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const SeeMoreLink = styled(Link)`
  display: block;
  text-align: right;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
  margin-top: 8px;
  text-decoration-color: ${({ theme }) => theme.palette.info.main};
`;

export const MoreBadge = styled('div')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 12px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.palette.info.light};
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  height: 36px;
  white-space: nowrap;
`;

export const TaskFieldSection = styled('div')`
  margin-top: 16px;
`;

export const TaskFieldLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 8px;
`;

export const TaskFieldValue = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const taskPriorityColors: Record<string, string> = {
  low: theme.palette.info.light,
  medium: '#D5BDFF',
  high: '#FF8461',
};

export const AssigneeListW = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 360px;
  overflow-y: auto;
  padding-right: 4px;
`;

export const AssigneeRow = styled(Typography)`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.p080};
  padding: 8px 12px;
  border-radius: 6px;
  background: ${({ theme }) => theme.palette.info.light};
`;

export const ProgressBarContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
`;

export const ProgressTrack = styled('div')`
  flex: 1;
  height: 4px;
  background: ${({ theme }) => theme.palette.primary.p010 ?? 'rgba(0, 0, 0, 0.08)'};
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressFill = styled('div')<{ value: number }>(({ theme, value }) => ({
  height: '100%',
  width: `${value}%`,
  background: theme.palette.info.main,
  borderRadius: '2px',
  transition: 'width 0.3s ease',
}));

export const ProgressLabel = styled(Typography)`
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.p050};
  min-width: 32px;
  text-align: right;
  flex-shrink: 0;
`;

export const TaskPriorityChip = styled(Typography)<{ priority: string }>(({ priority }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '36px',
  minWidth: '80px',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '18px',
  padding: '8px 16px',
  borderRadius: '4px',
  backgroundColor: taskPriorityColors[priority] ?? '#D5BDFF',
  textTransform: 'capitalize',
}));
